import { createAction } from 'shared/util/utility';
import { ActionType, SetDictionaryPayload } from './interface';

export function setDictionary(payload: SetDictionaryPayload) {
	return createAction(ActionType.SET_DICTIONARY, payload);
}
